if (!customElements.get('dual-slider')) {
  customElements.define(
    'dual-slider',
    class DualSlider extends HTMLElement {
      constructor() {
        super();
        this.sliderInstances = [];
      }
      connectedCallback() {
        // Find all swiper containers within this component
        const swipers = this.querySelectorAll('.swiper');
        
        swipers.forEach((swiper, index) => {
          this.initSlider(swiper, index);
        });
      }

      initSlider(swiper, index) {
        const sliderControls = swiper.parentElement.querySelector('.swiper-controls');
        const sliderPagination = sliderControls ? sliderControls.querySelector('.swiper-pagination') : null;
        const enableSlider = swiper.dataset.enableSlider === 'true';

        if (!enableSlider) return;

        const additionModules = [FoxTheme.Swiper.Autoplay, FoxTheme.Swiper.EffectFade];
        const sliderOptions = {
          slidesPerView: 1,
          loop: true,
          effect: 'fade',
          fadeEffect: { 
            crossFade: true 
          },
          navigation: {
            nextEl: sliderControls ? sliderControls.querySelector('.swiper-button-next') : null,
            prevEl: sliderControls ? sliderControls.querySelector('.swiper-button-prev') : null,
          },
          pagination: {
            el: sliderPagination,
            clickable: true,
          },
          on: {
            init: this.handleAfterInit.bind(this, sliderControls),
          },
        };

        const autoplayDelay = parseInt(swiper.dataset.autoplay);
        if (autoplayDelay > 0) {
          sliderOptions.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        const sliderInstance = new window.FoxTheme.Carousel(swiper, sliderOptions, additionModules);
        sliderInstance.init();

        sliderInstance.slider.on('realIndexChange', (swiperInstance) => {
          this.handleSlideChange(swiperInstance, sliderControls);
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId !== swiper.dataset.sectionId) return;
            const target = e.target;
            const blockType = target.dataset.type;
            if (blockType !== 'slide') return;
            const slideIndex = Number(target.dataset.index);
            sliderInstance.slider.slideToLoop(slideIndex);
          });
        }

        if (sliderInstance) {
          const motionTextElements = Array.from(swiper.querySelectorAll('motion-element[data-text]'));
          motionTextElements &&
            motionTextElements.forEach((motionTextElement) => {
              if (
                typeof motionTextElement.resetAnimation === 'function' &&
                !motionTextElement.closest('.swiper-slide-active')
              ) {
                motionTextElement.resetAnimation();
              }
            });
          const selectedElement = sliderInstance.slider.slides[sliderInstance.slider.activeIndex];
          this.onReady(selectedElement);

          const focusableElements = FoxTheme.a11y.getFocusableElements(swiper);
          focusableElements.forEach((element) => {
            if (!element.classList.contains('swiper-button')) {
              element.addEventListener('focusin', () => {
                const slide = element.closest('.swiper-slide');
                if (slide) {
                  sliderInstance.slider.slideToLoop(sliderInstance.slider.slides.indexOf(slide));
                }
              });
            }
          });
        }

        this.sliderInstances.push({
          swiper: swiper,
          instance: sliderInstance,
          controls: sliderControls
        });
      }

      onReady(selectedElement) {
        if (!FoxTheme.config.motionReduced) {
          const motionEls = selectedElement.querySelectorAll('motion-element');
          motionEls.forEach((motionEl) => {
            motionEl && motionEl.refreshAnimation();
          });
        }
      }

      handleAfterInit(sliderControls) {
        // Fix active bullet not transition on the first time.
        if (sliderControls) {
          const activeBullet = sliderControls.querySelector('.swiper-pagination-bullet-active');

          if (activeBullet) {
            activeBullet.classList.remove('swiper-pagination-bullet-active');
            activeBullet.offsetHeight; // Trigger reflow.
            activeBullet.classList.add('swiper-pagination-bullet-active');
          }
        }
      }

      handleSlideChange(swiperInstance, sliderControls) {
        const { slides, activeIndex } = swiperInstance;
        this.updateControlsScheme(slides[activeIndex], sliderControls);

        // Handle motion elements
        const activeSlide = slides[activeIndex];
        if (activeSlide) {
          setTimeout(() => {
            if (activeSlide.classList.contains('swiper-slide-active')) {
              const motionEls = activeSlide.querySelectorAll('motion-element');
              motionEls.forEach((motionEl) => {
                motionEl && motionEl.refreshAnimation();
              });
            }
          });
        }
      }

      updateControlsScheme(activeSlide, sliderControls) {
        if (sliderControls) {
          const classesToRemove = Array.from(sliderControls.classList).filter((className) =>
            className.startsWith('color-')
          );
          classesToRemove.forEach((className) => sliderControls.classList.remove(className));
          const colorScheme = activeSlide.dataset.colorScheme;
          if (colorScheme) {
            sliderControls.classList.add(colorScheme);
          }
        }
      }
    }
  );
}
